/** Date helpers for admin pump analytics date bar. */

export function todayDateString() {
  const date = new Date();
  return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
  ].join('-');
}

export function subtractDays(dateStr, days) {
  const [year, month, day] = dateStr.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  date.setDate(date.getDate() - days);
  return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
  ].join('-');
}

export function clampRange(fromDate, toDate, minDate, maxDate) {
  let from = fromDate;
  let to = toDate;
  if (minDate && from < minDate) from = minDate;
  if (maxDate && to > maxDate) to = maxDate;
  if (from > to) from = to;
  return { from_date: from, to_date: to };
}

export function financialYearStart(toDateStr) {
  const [year, month] = toDateStr.split('-').map(Number);
  const fyStartYear = month >= 4 ? year : year - 1;
  return `${fyStartYear}-04-01`;
}

/** Default to last 90 days within operation bounds. */
export function defaultAnalyticsRange(operationFrom, operationTo) {
  const to = operationTo || todayDateString();
  const fromCandidate = subtractDays(to, 89);
  const from = operationFrom && fromCandidate < operationFrom ? operationFrom : fromCandidate;
  return clampRange(from, to, operationFrom, operationTo);
}

export function daysBetween(fromDate, toDate) {
  const [y1, m1, d1] = fromDate.split('-').map(Number);
  const [y2, m2, d2] = toDate.split('-').map(Number);
  const start = new Date(y1, m1 - 1, d1);
  const end = new Date(y2, m2 - 1, d2);
  return Math.max(1, Math.round((end - start) / 86400000) + 1);
}

export function buildAnalyticsPresets(operationFrom, operationTo) {
  const to = operationTo || todayDateString();
  const last30 = clampRange(subtractDays(to, 29), to, operationFrom, operationTo);
  const last60 = clampRange(subtractDays(to, 59), to, operationFrom, operationTo);
  const last90 = clampRange(subtractDays(to, 89), to, operationFrom, operationTo);
  const quarter = clampRange(subtractDays(to, 91), to, operationFrom, operationTo);
  const fy = clampRange(financialYearStart(to), to, operationFrom, operationTo);
  const full = clampRange(operationFrom || last90.from_date, to, operationFrom, operationTo);

  return [
    { key: 'last30', label: 'Last 30 days', ...last30 },
    { key: 'last60', label: 'Last 60 days', ...last60 },
    { key: 'last90', label: 'Last 90 days', ...last90 },
    { key: 'quarter', label: 'Last quarter', ...quarter },
    { key: 'fy', label: 'This FY', ...fy },
    { key: 'full', label: 'Full operation', ...full },
  ];
}

/** Match applied range to a preset key for button highlighting. */
export function matchAnalyticsPreset(presets, fromDate, toDate) {
  if (!fromDate || !toDate) {
    return '';
  }
  const match = presets.find((p) => p.from_date === fromDate && p.to_date === toDate);
  return match?.key || '';
}

/** @deprecated use matchAnalyticsPreset */
export const matchAnalyticsPresets = matchAnalyticsPreset;
